import { render, staticRenderFns } from "./FirstLoginForm.vue?vue&type=template&id=07c9b733&"
import script from "./FirstLoginForm.vue?vue&type=script&lang=js&"
export * from "./FirstLoginForm.vue?vue&type=script&lang=js&"
import style0 from "./FirstLoginForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports